import { color } from "@chakra-ui/react";

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: [
        'container',
        'content',
        'linksContent',
        'copyrightContent',
        'subscribeContent',
        'localeSelector',
        'localeDropdown',
        'localeDropdownOption',
        'copyright',
        'socialIcons',
        'vat'
    ],
    baseStyle:  (props) => ({
        container: {
            width: 'full',
            background: 'white',
             ...(props.isPDP && {
                marginBottom: {base: 20, lg: '94px'}
            })
        },
        content: {
            maxWidth: 'container.xxxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            color: 'black',
            borderTop: '1px solid',
            borderTopColor: 'grey.400'
        },
        linksContent: {
            borderTop: {base: '1px solid', lg: 0},
            borderTopColor: 'grey.400',
            paddingTop: {base: 6},
            paddingBottom: {base: 6},
            paddingLeft: {base: 4, lg: 6},
            paddingRight: {base: 4, lg: 0}
        },
        copyrightContent: {
            borderTop: {base: '1px solid'},
            borderTopColor: 'grey.400',
            paddingTop: {base: 4, lg: 4},
            paddingBottom: {base: 4, lg: 4},
            paddingLeft: {base: 4, lg: 6},
            paddingRight: {base: 4, lg: 6}
        },
        subscribeContent: {
            margin: {base: '0 auto'},
            paddingTop: {base: 6},
            paddingBottom: {base: 6, lg: 9},
            paddingLeft: {base: 4, lg: 12},
            paddingRight: {base: 4, lg: 12},
            borderLeft: {lg: '1px solid'},
            borderLeftColor: {lg: 'grey.400'},
        },
        localeSelector: {
            display: 'inline-block',
            marginTop: 8
        },
        localeDropdown: {
            background: 'gray.800',
            _hover: {
                background: 'whiteAlpha.500'
            }
        },
        localeDropdownOption: {
            color: 'black'
        },
        copyright: {
            fontSize: 'xs',
            color: 'black',
            lineHeight: '15px',
            letterSpacing: '0px'
        },
        socialIcons: {
            marginTop: 4
        },
        vat: {
            display: {base: 'block', lg: 'inline-block'},
            paddingLeft: {lg: 1}
        }
    })
}
